import FondationsApiModel from '../global/FondationsApiModel';

export default class ServiceModel extends FondationsApiModel {
	static get path(): string {
		return '/services/{?id}';
	}
}
